import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCode, FiBriefcase, FiDollarSign, FiBookOpen, FiSettings } = FiIcons;

const RoleBadge = ({ role }) => {
  const roleConfig = {
    'Developer': {
      icon: FiCode,
      color: 'bg-blue-100 text-blue-800',
      label: 'Developer'
    },
    'Publisher': {
      icon: FiBriefcase,
      color: 'bg-green-100 text-green-800',
      label: 'Publisher'
    },
    'Investor': {
      icon: FiDollarSign,
      color: 'bg-yellow-100 text-yellow-800',
      label: 'Investor'
    },
    'Mentor': {
      icon: FiBookOpen,
      color: 'bg-purple-100 text-purple-800',
      label: 'Mentor'
    },
    'Admin': {
      icon: FiSettings,
      color: 'bg-red-100 text-red-800',
      label: 'Admin'
    }
  };

  const config = roleConfig[role] || roleConfig['Developer'];

  return (
    <span className={`inline-flex items-center space-x-1 px-2 py-1 rounded-full text-xs font-medium ${config.color}`}>
      <SafeIcon icon={config.icon} className="w-3 h-3" />
      <span>{config.label}</span>
    </span>
  );
};

export default RoleBadge;